import { FileText } from 'lucide-react'
import { useFreightDocuments } from '../api/queries'

export interface DocumentViewerProps {
  shipmentId: number
}

/**
 * Logistics overhaul Phase 2b — capability-aware document list for a
 * tendered shipment (BOL / POD / invoice). Some providers (TQL) have no
 * documents capability at all — the query errors (typed 501 from the
 * backend) and this renders nothing rather than a confusing error banner,
 * since "no documents available for this carrier" isn't actionable.
 */
export function DocumentViewer({ shipmentId }: DocumentViewerProps) {
  const { data, isLoading, isError } = useFreightDocuments(shipmentId)

  if (isLoading) {
    return <p className="m-0 text-sm text-tertiary">Loading documents…</p>
  }
  if (isError || !data || data.length === 0) {
    return null
  }

  return (
    <ul className="flex flex-col gap-1.5">
      {data.map((doc) => (
        <li key={doc.document_id} className="flex items-center gap-2 text-sm">
          <FileText size={14} className="text-tertiary" />
          {doc.url ? (
            <a
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent-text hover:underline"
            >
              {doc.filename ?? doc.doc_type ?? 'Document'}
            </a>
          ) : (
            <span>{doc.filename ?? doc.doc_type ?? 'Document'}</span>
          )}
          {doc.doc_type ? <span className="text-tertiary">· {doc.doc_type}</span> : null}
        </li>
      ))}
    </ul>
  )
}
